import { posthog } from 'posthog-js';
import type { EventProperties, RevenueData, PageViewData } from '../types';

let initialized = false;
let appName = '';

export function initPosthog(apiKey: string, host: string, app: string) {
  if (initialized || !apiKey) return;

  // Check if we're in a browser environment
  if (typeof window === 'undefined') return;

  posthog.init(apiKey, {
    api_host: host || 'https://app.posthog.com',
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') {
        posthog.opt_out_capturing();
      }
    },
  });

  appName = app;
  initialized = true;
}

export function trackEvent(event: string, properties?: EventProperties) {
  if (!initialized) return;

  posthog.capture(event, {
    ...properties,
    app_name: appName,
  });
}

export function identifyUser(userId: string, properties?: EventProperties) {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

export function trackRevenue(data: RevenueData) {
  if (!initialized) return;

  posthog.capture('revenue', {
    amount: data.amount,
    currency: data.currency || 'USD',
    plan: data.plan,
    user_id: data.userId,
    app_name: appName,
    ...data.metadata,
  });
}

export function trackPageView(data: PageViewData) {
  if (!initialized) return;
  
  const { path, userId, plan, ...extra } = data;
  
  posthog.capture('$pageview', {
    path,
    user_id: userId,
    plan,
    app_name: appName,
    ...extra,
  });
}
